import * as THREE from "three";

/** VideoTexture defaults for patrol 360° (stable on clip swap / live HLS). */
export function configurePatrolVideoTexture(texture) {
  texture.generateMipmaps = false;
  texture.minFilter = THREE.LinearFilter;
  texture.magFilter = THREE.LinearFilter;
  texture.wrapS = THREE.ClampToEdgeWrapping;
  texture.wrapT = THREE.ClampToEdgeWrapping;
}

/**
 * VideoTexture for equirectangular patrol playback.
 * flipY + inverted-X sphere geometry matches ThreeEquirectRenderer / wankhede-360.
 */
export function createPatrolEquirectVideoTexture(video) {
  const texture = new THREE.VideoTexture(video);
  configurePatrolVideoTexture(texture);
  texture.flipY = true;
  if (texture.colorSpace !== undefined) {
    texture.colorSpace = THREE.SRGBColorSpace;
  }
  return texture;
}

/**
 * Inner-view sphere mesh — `scale(-1, 1, 1)` avoids mirrored / reversed panorama.
 */
export function createPatrolEquirectSphereMesh(videoTexture, materialOptions = {}) {
  const geometry = new THREE.SphereGeometry(100, 120, 80);
  geometry.scale(-1, 1, 1);

  const material = new THREE.MeshBasicMaterial({
    map: videoTexture,
    toneMapped: materialOptions.toneMapped !== false,
    transparent: materialOptions.transparent === true,
    opacity: materialOptions.opacity ?? 1,
    depthWrite: materialOptions.depthWrite !== false,
  });

  return new THREE.Mesh(geometry, material);
}
